$(document).ready(function() {
    var productID = $('.product-number span.product-id');
    var productTitle = $('h1.product-name');
    if(productID && productTitle){
        var productIsProtectionPlanID = productID.text().toLowerCase().indexOf("plan-m") >= 0;
        var productTitleIsProtectionPlan = productTitle.text().toLowerCase().indexOf("protection plan") >= 0;
        if(productIsProtectionPlanID && productTitleIsProtectionPlan){
            $('#planYears-1 option:eq(2)').prop('selected', true);
            $('#planYears-1')
                .find('option:nth-child(2)')//find One years plan as Default
                .prop('selected',true)//select three years plan
                .trigger('change'); //trigger a change instead of click                
        }
    }    
});
